// @mui material components
import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import InformationHome from "pages/Servicii/ServiciiCuratenie/CuratenieIntretinere/sections/sections/InformationHome";
import TestimonialsHome from "pages/Servicii/ServiciiCuratenie/CuratenieIntretinere/sections/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiCuratenie/CuratenieIntretinere/sections/sections/HeroSection";
import ServicesSection from "pages/Servicii/ServiciiCuratenie/CuratenieIntretinere/sections/sections/Services";
import ArticleContent from "pages/Servicii/ServiciiCuratenie/CuratenieIntretinere/sections/sections/ArticleContent";

function CuratenieIntretinere() {
    return (
        <>
            <Helmet>
                <title>Curățenie de întreținere pentru birouri și spații comerciale</title>
                <meta
                    name="description"
                    content="Curățenie de întreținere pe bază de contract pentru birouri, clinici și spații comerciale din București și Ilfov: intervenții zilnice sau periodice."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/curatenie-de-intretinere/" />
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "@id": "https://doral-cleaning.ro/#business",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "url": "https://doral-cleaning.ro/",
                      "telephone": "0730 407 322",
                      "foundingDate": "2006",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4",
                        "addressLocality": "București",
                        "postalCode": "040213",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" },
                        { "@type": "City", "name": "Voluntari" },
                        { "@type": "City", "name": "Pantelimon" },
                        { "@type": "City", "name": "Popești-Leordeni" },
                        { "@type": "City", "name": "Bragadiru" },
                        { "@type": "City", "name": "Măgurele" },
                        { "@type": "City", "name": "Chitila" },
                        { "@type": "City", "name": "Buftea" },
                        { "@type": "City", "name": "Otopeni" }
                      ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "Service",
                      "name": "Curățenie de întreținere",
                      "serviceType": "Curățenie de întreținere pe contract",
                      "url": "https://doral-cleaning.ro/curatenie-de-intretinere/",
                      "provider": { "@id": "https://doral-cleaning.ro/#business" },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" }
                      ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "FAQPage",
                      "@id": "https://doral-cleaning.ro/curatenie-de-intretinere/#faq",
                      "url": "https://doral-cleaning.ro/curatenie-de-intretinere/",
                      "inLanguage": "ro-RO",
                      "mainEntity": [
                        {
                          "@type": "Question",
                          "name": "Lucrați și în afara Sectorului 4?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Da. Sediul nostru este în Sectorul 4, dar lucrăm în toate sectoarele Bucureștiului și în Ilfov, inclusiv în Voluntari, Pantelimon, Popești-Leordeni, Bragadiru, Măgurele, Chitila, Buftea și Otopeni. Deplasarea pentru evaluare este gratuită."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Cât de des este recomandată curățenia de întreținere într-un birou?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Frecvența depinde de numărul de angajați, traficul zilnic și tipul activității. Pentru majoritatea birourilor, intervențiile zilnice sau de câteva ori pe săptămână oferă un nivel constant de igienă și ordine."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Ce include, de regulă, un serviciu de curățenie de întreținere?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "În mod obișnuit, serviciul include ștergerea prafului, aspirare, spălarea pardoselilor, igienizarea grupurilor sanitare, golirea coșurilor și întreținerea zonelor comune. Lista exactă se stabilește în funcție de spațiu și necesități."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Se poate face un program de curățenie în afara orelor de lucru?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Da. Pentru a nu perturba activitatea companiei, intervențiile pot fi programate dimineața devreme, seara sau în intervale stabilite de comun acord. Programul se adaptează fluxului operațional al clientului."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Cum se calculează prețul pentru curățenie de întreținere?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Prețul este influențat de suprafață, frecvența intervențiilor, gradul de utilizare al spațiului, tipul finisajelor și serviciile incluse. O evaluare inițială ajută la stabilirea unei oferte corecte și personalizate."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Este necesar un contract pentru acest tip de serviciu?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Da, în cazul intervențiilor recurente. Contractul clarifică frecvența, serviciile incluse, responsabilitățile și modul de desfășurare a colaborării."
                          }
                        },
                        {
                          "@type": "Question",
                          "name": "Ce se întâmplă dacă spațiul are nevoie inițial de o curățenie mai amplă?",
                          "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Dacă spațiul este foarte încărcat sau recent amenajat, se poate recomanda mai întâi o curățenie generală sau post constructor. După ce spațiul este adus la un standard bun, se poate continua cu întreținerea periodică."
                          }
                        }
                      ]
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
                <ServicesSection />
            </Card>
        </>
    );
}

export default CuratenieIntretinere;
